import React from 'react';
import { MAIN_PRODUCT, PRODUCT_VERSION } from '../utils/config';

export const useId3Actions = () => {
  const [mainProduct, setMainProduct] = React.useState(MAIN_PRODUCT);
  const [versionProduct, setVersionProduct] = React.useState(PRODUCT_VERSION);
  const [actionValue, setActionValue] = React.useState('');

  React.useEffect(() => {
    const root = document.getElementById('root');
    if (root) {
      const { baseProductId, versionProductId, actionValue } = root.dataset || {
        baseProductId: '',
        versionProductId: '',
        actionValue: '',
      };

      if (baseProductId) setMainProduct(baseProductId);
      if (versionProductId) setVersionProduct(versionProductId);
      if (actionValue) setActionValue(actionValue);
    }
  }, []);

  const actionTarget = React.useCallback(() => {
    //@ts-ignore
    if (typeof window.AuthButton?.saveAction === 'function') {
      //@ts-ignore
      window.AuthButton.saveAction([
        22 /*action id*/,
        'uatarget' /* name action*/,
        window.location.href /*source*/,
        mainProduct /*category1*/,
        versionProduct /*category2*/,
        actionValue,
      ]);
    }
  }, [mainProduct, versionProduct, actionValue]);

  return {
    actionTarget,
  };
};
